export default {"src":"/_next/static/media/ico_zoom_in.db6c41ba.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};